module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iterators.js
// module id = 36
// module chunks = 18